module.exports = __webpack_public_path__ + "img/hero-thumb-4.2031f5c7.png";